import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/trade-intelligence/components/TradeIntelligencePage.tsx");
